import React from 'react';
import { ReactComponent as MPfull} from './../assets/logos/MOBIUSPACK.svg'
import backgroundSVG from './../assets/logos/background-mob.svg';
import { Button, Box } from '@mui/material';

export function ErrorPage({errorCode = '404', message = 'Page non trouvée'}) {
    const handleGoHome = () => {
        window.location.href = '/v2';
    };

    const style = {
        container: {
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            backgroundColor: '#F2F2F7',
            textAlign: 'center',
            padding: '2rem',
            backgroundImage: `url(${backgroundSVG})`,
            backgroundSize: 'cover',
            backgroundPosition: 'right 50% top -50vw',
            backgroundRepeat: 'no-repeat',
            minHeight: '100vh',
            width: '100%',
            maxWidth: '100vw',
            overflowX: 'hidden',
            boxSizing: 'border-box',
        },
        contentBox: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            flexGrow: 0.7,
        },
        title404: {
            fontSize: '6rem',
            fontWeight: 700,
            color: '#56a6c3',
            margin: 0
        },
        subtitle: {
            fontSize: '1.5rem',
            fontWeight: 400,
            color: '#333',
            marginTop: '1rem'
        },
        button: {
            textTransform: 'none',
            marginTop: '1rem',
            paddingInline: '1.5rem'
        }
    };

    return (
        <div style={style.container}>
            <MPfull style={{maxWidth:'20rem', alignSelf:'center'}} />
            <Box sx={style.contentBox}>
                <h1 style={style.title404}>{errorCode}</h1>
                <h2 style={style.subtitle}>{message}</h2>
                <Button variant='contained' sx={style.button} onClick={handleGoHome}>
                    Redirection vers l'accueil
                </Button>
            </Box>
        </div>
    );
}
